<template>
  <div class="form-item-panel">
    <template v-if="data.id">
      <div class=" record " :class="isPad?'pad-font':''" style="margin-top: 5px" v-show="data.inputTip" v-html="data.inputTip">        
      </div>
      <!-- 量表结论展示-->
      <div class="record-result" :class="isPad?'pad-font':''" style="margin-top: 5px" v-if="resultFormItemList.length>0 && data.status!=='1'&&data.status!=='2'">
        <template v-for="(formItem,index) in resultFormItemList">
          <div :key="index">
            <div>
              {{formItem.name}}：{{formItem.value||''}}
            </div>
            <div>
              {{formItem.name}}结论：{{formItem.result||'-'}}
            </div>
          </div>
        </template>
      </div>
      <a-form-model :model="form" ref="ruleForm" layout="vertical" style="padding-left: 20px;padding-right: 20px;" :rules="rules" >
        <template v-for="(item,index) in data.formItemList">
          <form-view-item :baseData="data" :readOnly="readOnly" @valueChange="itemValueChange" :questionList="questionList" :show-tip-btn="showTipBtn" :form-item="item" :form.sync="form" v-if="item.scale!=='1'" :key="index"></form-view-item>
        </template>
        <div style="text-align: right;margin-top: 50px;">
          <slot name="btn"></slot>
        </div>
      </a-form-model>
    </template>
    <a-modal
      title="结论"
      :width="800"
      :visible="resultVisible"
      switchFullscreen
      @ok="resultVisible = false"
      @cancel="resultVisible = false"
      cancelText="关闭">
    <div class="record-result" style="margin-top: 5px" v-if="resultFormItemList.length>0 && data.status!=='1'&&data.status!=='2'">
      <template v-for="(formItem,index) in resultFormItemList">
        <div  :key="index">
          <div>
            {{formItem.name}}：{{formItem.value||''}}
          </div>
          <div>
            {{formItem.name}}结论：{{formItem.result||'-'}}
          </div>
        </div>
      </template>
    </div>
    </a-modal>
  </div>
</template>

<script>
  import FormViewItem from './FormViewItem'
  import {elementTypeData ,CACHE_PROJECT_ID} from '@/constants/project'
  import baseRules from '@/constants/baseRules'
  import {CACHE_IS_PAD } from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'

  export default {
    name: 'FormView',
    components: { FormViewItem },
    props:{
      questionList:{
        type:Array,
        default(){
          return []
        }
      },
      readOnly:{
        type:Boolean,
        default:false,
      },
      baseData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      showTipBtn:{
        type:Boolean,
        default:false
      },
      isLoad:{
        type:Boolean,
        default:true
      },
      showQuestionItem:{
        type:Boolean,
        default:false
      }
    },
    // created(){
    //   this.rules = baseRules(this.data)

    // },
    computed:{

    },
    watch:{
      baseData(){
        if(this.isLoad){
          this.loadData()
        }
      }
    },
    mounted(){
      if(this.isLoad){
        this.loadData()
      }
    },
    data(){
      return {
        elementTypeData:elementTypeData,
        data:{
          formItemList:[]
        },
        resultFormItemList:[],
        form:{},

        rules : {},
        isPad:Vue.ls.get(CACHE_IS_PAD),
        resultVisible:false,
      }
    },
    methods:{
      resultFormItemListHandle(){
        if(!this.data || !this.data.formItemList){
          return []
        }
        return this.data.formItemList.filter(formItem=>formItem.conceal!=='1' && formItem.scale==='1')
      },
      itemValueChange(formItem,value){
        if(this.$refs.ruleForm){
          this.$emit('formChange',formItem)
        }

      },
      validate(){
        let validResult = false
        let errResult = {  }
        this.$refs.ruleForm.validate((valid,errorData)  => {
          validResult = valid
          if(!valid){
            errResult = errorData
          }
        })
        return [validResult,errResult]
      },
      // 查找质疑题目
      findItem(formItem, itemId){
        if(formItem.children && formItem.children.length>0){
          for(let i=0;i<formItem.children.length;i++){
            if(formItem.children[i].id === itemId){
              return true
            }else{
              if(this.findItem(formItem.children[i], itemId)){
                return true
              }
            }
          }
        }else{
          return false
        }
      },
      loadData(resultView){
        console.log('loadData:'+this.showQuestionItem)
        this.data = JSON.parse(JSON.stringify(this.baseData))
        if(this.showQuestionItem && this.questionList.length>0){//查看有质疑的题目
            var result = []      
            this.questionList.forEach(question=>{
              var items = this.data.formItemList.filter(item=> question.formItemId === item.id)
              if(items.length>0){//如果有质疑的题目
                result = result.concat(items)
              }else{//如果没有质疑的题目，需要查找子题目
                for(let i=0;i<this.data.formItemList.length;i++){
                  var findResult = this.findItem(this.data.formItemList[i],question.formItemId)
                  if(findResult){//找到了质疑的题目
                    result.push(this.data.formItemList[i])
                    break
                  }
                }
              }
            })
            const newArray = [];
            result.forEach(item => {
              if (!newArray.some(obj => obj.id === item.id)) {
                newArray.push(item);
              }
            });
            newArray.sort((a, b) => a.sortNum - b.sortNum);
            this.data.formItemList = newArray
        }
        this.resultFormItemList = this.resultFormItemListHandle()
        const form = {}
        this.initFrom(this.data.formItemList,form)
        this.form = form
        // 还要创建rules
        this.rules = {}
        const rules = {name:[{"required":true,"message":"请输入内容","trigger":"blur"}],}
        // if(this.data.formItemList){
        //   this.data.formItemList.forEach(item=>{
        //     if('1' === item.required){
        //       rules[item.id] = [baseRules.required]
        //     }
        //   })
        // }
        this.requiredRule(rules,this.data.formItemList)
        this.rules = rules
        this.$nextTick(()=>{
          if(resultView && this.resultFormItemList.length>0){
            this.resultVisible = true
          }
        })
      },
      requiredRule(rules,itemList){
        if(itemList){
          itemList.forEach(item=>{
            if('1' === item.required){
              rules[item.id] = [baseRules.required]
            }
            if(item.element && item.element.checkReg){
              rules[item.id] = rules[item.id] || []
              rules[item.id].push({pattern: new RegExp(item.element.checkReg) , message: '请输入正确格式内容', trigger: 'change'})
            }
            if(item.children){
              this.requiredRule(rules,item.children)
            }
          })
        }
      },
      initFrom(formItemList,form){
        if(formItemList && formItemList.length>0){
          formItemList.forEach(item=>{
            let value = item.value
            if(value){
              if(item.element && item.element.type ===elementTypeData.number.value ){
                if(item.element.reDecimal==='1'){
                  value = parseFloat(value)
                }else{
                  value = parseInt(value)
                }
              }
              else if(item.element&& item.element.type ===elementTypeData.check.value ){
                value = value.split(',')
              }
              else if(item.element && elementTypeData.slider.value === item.element.type ){
                value = parseInt(value)
              }
              form[item.id] = value
            }else if(item.element && item.element.type ===elementTypeData.check.value){
              form[item.id] = []
            }
            else if(item.element && item.element.type ===elementTypeData.slider.value){
              form[item.id] = item.element.minLength || 0
            }
            else{
              form[item.id] = ''
            }
            this.initFrom(item.children,form)
          })
        }
      },
      getFormData(){
        return this.form
      },
      setFormData(key,value){
        this.$set(this.form,key,value)
      },
    }
  }
</script>

<style scoped lang="less">
  .record{
    border:1px solid rgba(57,188,206,0.5);
    border-radius: 5px;
    padding: 10px;
    background-color: #E7F3E2;
    color:#59C62C;
  }
  .record-result{
    border:1px solid rgba(57,188,206,0.5);
    border-radius: 5px;
    padding: 10px;
    color:#4291C6;
  }
  .pad-font{
    font-size: 13px;
  }
</style>